<script lang="ts">
  export let type: string;
  export let title: string;
  export let backgroundDesktopImage: string | null = null;
  export let backgroundMobileImage: string | null = null;
  export let cssClass: string = '';

  if (type === 'Una settimana ricca di appuntamenti') {
    cssClass = 'brand-color';
  }

  console.log('style', $$restProps.style);
</script>

<!-- Add route class to enable custom color -->
<section
  class="hero-path {cssClass}"
  {...$$restProps}
>
  <div class="hero-grid">
    {#if backgroundDesktopImage}
      <div class="hero-image-wrapper">
        {#if backgroundMobileImage}
          <img
            src={backgroundDesktopImage}
            srcset="{backgroundMobileImage} 768w, {backgroundDesktopImage}"
            sizes="(max-width: 768px) 768px"
            alt={title}
            class="hero-image"
          />
        {:else}
          <img
            src={backgroundDesktopImage}
            alt={title}
            class="hero-image"
          />
        {/if}
      </div>
    {/if}
    <div class="hero-title">
      <p class="hero-path-type">
        {#if $$slots.type}
          <slot name="type" />
        {:else}
          {type}
        {/if}
      </p>
      <h1 class="hero-path-title">
        {#if $$slots.title}
          <slot name="title" />
        {:else}
          {title}
        {/if}
      </h1>
    </div>

    <div class="hero-content">
      <div class="hero-content-text">
        <slot />
      </div>
    </div>
  </div>
</section>

<style type="text/scss" lang="scss" scoped>
  .hero-path {
    --hero-height: 400px;
    @apply bg-transparent;
    @apply relative;
  }

  .hero-grid {
    @apply grid grid-cols-default;
    @apply gap-x-grid-default;
    @apply w-full;
    @apply md:page-margin md:page-max-width;
    @apply bg-tint text-contrast-tint;
    @apply md:mb-24;

    @screen md {
      height: var(--hero-height);
    }

    &:before {
      content: '';
      @apply hidden;
      @apply md:block;
      @apply md:bg-tint md:text-contrast-tint;
      @apply md:absolute md:inset-0;
    }
  }

  .hero-image-wrapper {
    @apply absolute;
    @apply w-full h-full;
    @apply top-0 right-0 bottom-0 left-0;
    @apply z-10;

    .hero-image {
      @apply object-cover object-center;
      @apply w-full h-full;
    }
  }

  .hero-path-type {
    @apply uppercase tracking-wider font-semibold;
    @apply text-contrast-tint text-opacity-50 text-sm md:text-base;
  }

  .hero-path-title {
    @apply text-md md:text-6xl leading-snug md:leading-tighter;
    @apply text-contrast-tint font-medium font-serif;
  }

  .hero-path-type + .hero-path-title {
    @apply mt-3;
  }

  .hero-title {
    @apply relative;
    @apply col-span-full;
    @apply page-margin py-12 md:p-0;
    @apply md:row-start-1 md:col-start-1 md:col-span-6 xl:col-span-5;
    @apply md:self-center;
    z-index: 20;
  }

  .hero-content {
    @apply relative;
    @apply bg-gray-50 md:bg-white;
    @apply py-6 page-margin md:p-8;
    @apply col-span-full;
    @apply md:row-start-1 md:col-start-7 md:col-span-6;
    @apply md:self-end md:-mb-12;
    @apply text-black;
    z-index: 20;
  }

  .hero-content-text {
    @apply leading-relaxed;
  }
</style>
